<template>
  <div class="wrap">
    <p class="type">
      <span class="title"> 2026 年 01 月 正常工资薪金所得</span>
    </p>
    <div class="opt-btn">
      <el-space :size="14">
        <!-- <el-button type="primary" >添加</el-button> -->
        <el-button type="primary" @click="changeTab">返回</el-button>

        <el-button type="primary" @click="addData">添加</el-button>

        <el-dropdown>
          <el-button type="primary">
            导入
            <el-icon style="margin-left: 3px;">
              <ArrowDown/>
            </el-icon>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>
                <el-upload
                    :action="uploadPersonUrl"
                    :limit="999"
                    :show-file-list="false"
                    accept=".xlsx, .xls"
                    :headers="headers"
                    name="file"
                    :before-upload="beforeUp"
                    :on-success="handleSu"
                    :on-progress="onStart"
                    :on-error="onError"
                >
                  <el-link :underline="false">导入文件</el-link>
                </el-upload>

              </el-dropdown-item>
              <el-dropdown-item>
                <el-link :underline="false"
                         href="https://renhe-platform-prod.oss-cn-shanghai.aliyuncs.com/%E6%AD%A3%E5%B8%B8%E5%B7%A5%E8%B5%84%E8%96%AA%E9%87%91%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls?v=2"
                >下载模板
                </el-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>

        <el-button type="primary" @click="dialogVisible = true">预填专项附加扣除</el-button>
      </el-space>
      <el-space :size="14">
        <el-button type="primary" plain>导出</el-button>
        <el-button type="primary" plain>展开查询条件</el-button>
        <el-button type="primary" plain>更多操作</el-button>
      </el-space>
    </div>
    <vxe-table
        border
        keep-source
        ref="tableRef"
        show-footer
        :footer-data="footerData"
        :edit-config="{trigger: 'click', mode: 'row', showStatus: false}"
        :data="tableData"
        :max-height="maxHeight"
    >
      <vxe-column type="checkbox" width="55"></vxe-column>
      <vxe-column field="employeesNo" title="工号" width="150"/>
      <vxe-column field="name" title="姓名" width="150"/>
      <vxe-column field="certificateType" title="证件类型" width="150"/>
      <vxe-column field="idNumber" title="证件号码" width="150"/>
      <vxe-column field="startDate" title="所得期间起" width="150"/>
      <vxe-column field="endDate" title="所得期间止" width="150"/>
      <vxe-column title="所得项目" width="150">
        <template #default>
          <span>正常工资薪金</span>
        </template>
      </vxe-column>
      <template v-for="(item,index) in answerColumn">
        <vxe-column
            width="150"
            :key="index"
            :field="item.key"
            :title="item.title"
            :edit-render="{}"
            v-if="!['应补退税额'].includes(item.title)"
        >
          <template #edit="{ row }">
            <el-input-number @change="updateFootEvent" :disabled="['减除费用'].includes(item.title)"
                             placeholder="请输入" v-model="row[item.key]" style="width: 130px;" :controls="false"
                             :precision="2" :step="10"/>
          </template>
          <template #default="{ row }">
            <span>{{ row[item.key] }}</span>
          </template>
        </vxe-column>
      </template>
      <vxe-column field="remark" title="备注" width="150" :edit-render="{}">
        <template #edit="{ row }">
          <el-input v-model="row.remark"/>
        </template>
        <template #default="{ row }">
          <span>{{ row['remark'] }}</span>
        </template>
      </vxe-column>
    </vxe-table>
    <el-dialog
        v-model="dialogVisible"
        title="提示"
        width="600"
    >
      <div class="tip_dialog">
        <p class="title">温馨提示：</p>
        <p>
          <b>本税款所属期已计税并据以发放工资，请勿重新预填，</b>
          避免因专项附加扣除信息变化导致重新计算的税款与此前代扣款不一致。
        </p>
        <p>
          <b>
            请确认系统中的专项附加扣除采集信息已采集完毕
          </b>
          ，从税务端下载其他渠道采集的信息
        </p>
        <p style="margin-top: 20px;">
          <el-checkbox v-model="checked">我确认需要进行自动预填</el-checkbox>
        </p>
        <div>
          <p>预填人员范围</p>
          <el-radio-group v-model="radio">
            <el-radio :value="1">所有人员</el-radio>
            <el-radio :value="2" disabled>选中人员</el-radio>
          </el-radio-group>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="updateData">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <one51-guide-dialog
        v-model:visible="oneGuiVis"
        @exeInit="autoInit"
    />

    <one51-add-dialog
        v-model:visible="addVis"
        @confirm="afterAdd"
    />

  </div>
</template>

<script setup>
import {onMounted, onUnmounted} from 'vue';
import {answer, initialAnswerColumn, answerColumn} from '../../config.js'
import {useTaxStore} from '@/store/modules/tax.js'
import {getToken} from "@/utils/auth.js";
import {ElLoading, ElMessage, ElMessageBox} from "element-plus";
import one51GuideDialog from "./one51GuideDialog.vue";
import One51AddDialog from "./one51AddDialog.vue";
import {useOnResize} from "./oneResizeHandler.js";

const taxStore = useTaxStore()
const {transferAdditionalList, answer: answerList, userAnswer} = storeToRefs(taxStore);
const tableData = ref([])
const tableRef = ref(null)
const footerData = ref([
  {employeesNo: '合计'},
])
const genTableList = () => {
  let otherParams = {}
  answerColumn.forEach(item => {
    if (item.title != '应补退税额') {
      otherParams[item.key] = 0;
      if (item.title == '减除费用') {
        otherParams[item.key] = 5000
      }
      footerData.value[0][item.key] = '-'
    }
  })
  tableData.value = []
  transferAdditionalList.value.forEach(item => {
    let res = {
      employeesNo: item.employeesNo,
      name: item.name,
      certificateType: item.certificateType,
      idNumber: item.idNumber,
      startDate: "2026-01-01",
      endDate: "2026-01-31",
      remark: "",
      ...otherParams
    }
    let obj = userAnswer.value.find(it => it.idNumber == item.idNumber)
    if (obj) {
      res = {...res, ...item, ...obj}
    }
    tableData.value.push(res)
  })
  updateFootCount(tableData.value)
}

const oneGuiVis = ref(false)

// 第一次的引导弹层
function firstGuide() {
  ElMessageBox.confirm("您本月[2026年01月]还没有生成过正常工资薪金明细数据。需要使用自动导入正常工资薪金数据向导吗？", "确认消息", {
    type: 'warning',
  })
      .then(() => {
        oneGuiVis.value = true
      })
      .catch(() => {});
}

function autoInit() {
  genTableList()
  ElMessageBox.confirm("系统已根据人员登记信息生成了[202601]月份的工资薪金数据，请检查！", "提示信息", {
    type: 'warning',
    showCancelButton: false,
  })
      .then(() => {
      })
      .catch(() => {});
}

const dialogVisible = ref(false)
const updateData = () => {
  const initKeys = initialAnswerColumn.map(item => item.key)
  tableData.value = tableData.value.map(item => {
    const info = transferAdditionalList.value.find(it => item.idNumber == it.idNumber)
    if (info) {
      initKeys.forEach(key => {
        item[`Answer_${key}`] = info[key]
      })
    }
    return item

  })
  dialogVisible.value = false;
  updateFootEvent()
}

const sumNum = (list, field) => {
  let count = 0
  list.forEach(item => {
    count += Number(item[field])
  })
  return count.toFixed(2)
}
const updateFootCount = (list) => {
  const [sumNObj] = footerData.value;
  answerColumn.forEach(item => {
    if (item.title != '应补退税额') {
      sumNObj[item.key] = sumNum(list, item.key)
    }
  })
}
const checked = ref(true)
const radio = ref(1)
// 在值发生改变时更新表尾合计
const updateFootEvent = () => {
  const $table = tableRef.value
  if ($table) {
    const {visibleData} = $table.getTableData()
    updateFootCount(visibleData)
  }
}
const emits = defineEmits(['changeTab'])
const changeTab = () => {
  emits('changeTab', 'default')
}

const maxHeight = ref('300px')

onMounted(() => {
  // 专项附加扣除已执行，并且当前未生成答案，说明是第一次
  if (userAnswer.value.length == 0 && transferAdditionalList.value.length) {
    firstGuide()
  }
  if (userAnswer.value.length) { // 已经生成过数据
    genTableList()
  }
  maxHeight.value = ((window.innerHeight | document.documentElement.clientHeight | document.documentElement.clientHeight) - 330) + 'px'
})
onUnmounted(() => {
  taxStore.setUserAnswer(tableData.value)
})

useOnResize(() => {
  maxHeight.value = ((window.innerHeight | document.documentElement.clientHeight | document.documentElement.clientHeight) - 330) + 'px'
})

/*
 * 导入相关
 */
const uploadPersonUrl = ref(import.meta.env.VITE_APP_BASE_API + "/system/exam/importDataInfo"); // 导入人员接口地址
const headers = ref({Authorization: "Bearer " + getToken()});

function beforeUp(file) {
  if (file.size > 10 * 1024 * 1024) {
    ElMessage.error('文件太大，最大支持10M!')
    return false
  }
  const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
  if (!['xls', 'xlsx', 'XLS', 'XLSX'].includes(suffix)) {
    ElMessage.error('上传文件类型错误!')
    return false
  }
  return true
}

let loadingInstance

function onStart() {
  loadingInstance = ElLoading.service({
    text: "正在上传，请稍候",
    background: "rgba(0, 0, 0, 0.5)",
    body: true,
  })
}


function handleSu(resp) {
  loadingInstance.close()
  if (resp.code !== 200) {
    ElMessage.error('导入失败，请重试')
    return
  }
  // 上传成功
  const importData = (resp.data || []).filter(f => tableData.value.some(s => s.idNumber == f.idNumber))
  importData.forEach(it => {
    const tr = tableData.value.find(row => row.idNumber == it.idNumber) || {}
    tr.Answer_CurrentIncome = it.answer_CurrentIncome || 0
    tr.Answer_CurrentExemptIncome = it.answer_CurrentExemptIncome || 0
    tr.Answer_BasicEndowmentInsurance = it.answer_BasicEndowmentInsurance || 0
    tr.Answer_BasicMedicalInsurance = it.answer_BasicMedicalInsurance || 0
    tr.Answer_UnemploymentInsurancePremium = it.answer_UnemploymentInsurancePremium || 0
    tr.Answer_HousingAccumulationFund = it.answer_HousingAccumulationFund || 0
  })
  updateFootEvent()
  ElMessage.info(`成功导入了${importData.length}条数据`)
}

function onError() {
  loadingInstance.close()
}

const addVis = ref(false)

function addData() {
  addVis.value = true
}

function afterAdd(data) {
  const tr = tableData.value.find(row => row.idNumber == data.idNumber) || {}
  // 前6个导入类字段
  tr.Answer_CurrentIncome = data.Answer_CurrentIncome || 0
  tr.Answer_CurrentExemptIncome = data.Answer_CurrentExemptIncome || 0
  tr.Answer_BasicEndowmentInsurance = data.Answer_BasicEndowmentInsurance || 0
  tr.Answer_BasicMedicalInsurance = data.Answer_BasicMedicalInsurance || 0
  tr.Answer_UnemploymentInsurancePremium = data.Answer_UnemploymentInsurancePremium || 0
  tr.Answer_HousingAccumulationFund = data.Answer_HousingAccumulationFund || 0 // 住房公积金

  tr.Answer_CumulativeChildEducation = data.Answer_CumulativeChildEducation || 0
  tr.Answer_CumulativeContinuingEducation = data.Answer_CumulativeContinuingEducation || 0
  tr.Answer_AccumulatedHousingLoanInterest = data.Answer_AccumulatedHousingLoanInterest || 0
  tr.Answer_AccumulatedHousingRent = data.Answer_AccumulatedHousingRent || 0
  tr.Answer_SupportTheElderlyCumulatively = data.Answer_SupportTheElderlyCumulatively || 0
  tr.Answer_AccumulatedInfantChild = data.Answer_AccumulatedInfantChild || 0
  //tr.Answer_CumulativeInfantCare = data.Answer_CumulativeInfantCare //大病医疗？？里面无此字段
  tr.Answer_EnterpriseAnnuity = data.Answer_EnterpriseAnnuity || 0
  tr.Answer_CommercialHealthInsurance = data.Answer_CommercialHealthInsurance || 0
  tr.Answer_TaxdeferredPensionInsurance = data.Answer_TaxdeferredPensionInsurance || 0
  tr.Answer_PreDeductibleContributions = data.Answer_PreDeductibleContributions || 0 // 准予扣除的捐赠款
  tr.Answer_TaxRelief = data.Answer_TaxRelief || 0 // 减免税额
  tr.Answer_TheAmountTaxWithheld = data.Answer_TheAmountTaxWithheld || 0 // 已扣缴税额

  tr.remark = data.remark // 备注
  updateFootEvent()
}
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;

  :deep(.el-table) {
    --el-table-header-bg-color: #f8f9fa;
  }

  .type {
    height: 60px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .title {
      height: 20px;
      border-left: 4px solid var(--el-color-primary);
      box-sizing: border-box;
      line-height: 20px;
      text-indent: 12px;
    }
  }

  .opt-btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .tip_dialog {
    padding: 32px;
    box-sizing: border-box;

    .title {
      line-height: 40px;
      font-size: 16px;
    }

    p {
      line-height: 30px;
    }
  }
}
</style>
